import { KnownCodableConceptCode } from "@intocare/datatypes/lib/concept";

import { FollowUpPlanCreation } from "./follow-up-plan-creation";

export interface FollowUpPlanCreationDto {
	title: string;
	problemStatement: string;
	careThemes: KnownCodableConceptCode[];
	residentId: string;
}

export const convertToFollowUpPlanCreationDto = (formData: FollowUpPlanCreation): FollowUpPlanCreationDto => {
	const { careTheme, ...rest } = formData;
	return {
		...rest,
		careThemes: [careTheme],
	};
};
